import { render } from "./SubmittedCard.vue?vue&type=template&id=ebdb2282&scoped=true"
import script from "./SubmittedCard.vue?vue&type=script&lang=js"
export * from "./SubmittedCard.vue?vue&type=script&lang=js"

import "./SubmittedCard.vue?vue&type=style&index=0&id=ebdb2282&scoped=true&lang=css"

import exportComponent from "C:\\Users\\s576427\\Supplemental\\Supplemental UI\\suppl-material-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebdb2282"]])

export default __exports__